export default {
    setDrug: (state, drug) => { state.drug = drug },
    setDrugsSummary: (state, drugsSummary) => { state.drugsSummary = drugsSummary },
    setSummaryTemp: (state, summaryTemp) => { state.summaryTemp = summaryTemp },
    setProductsSummary: (state, productsSummary) => { state.productsSummary = productsSummary },
    setDose: (state, dose) => { state.dose = dose },
    setDrugTab: (state, drugTab) => { state.drugTab = drugTab },
    setProduct: (state, product) => { state.product = product },
    setVeterinaryProductsMap: (state, veterinaryProductsMap) => { state.veterinaryProductsMap = veterinaryProductsMap },
    setHumanProductsMap: (state, humanProductsMap) => { state.humanProductsMap = humanProductsMap },
    setDoseIndex: (state, dose_index) => { state.dose_index = dose_index },
    setReference: (state, reference) => { state.reference = reference },
    setShowProducts: (state, showProducts) => { state.showProducts = showProducts },
    setVirtualScroll: (state, virtualScroll) => { state.virtualScroll = virtualScroll },
    setSearchValue: (state, searchValue) => { state.searchValue = searchValue },
    setClasses: (state, classes) => { state.classes = classes },
    setCategory: (state, category) => { state.category = category },
    setItemsList: (state, itemsList) => { state.itemsList = itemsList },
    setHasFilter: (state, hasFilter) => { state.hasFilter = hasFilter },
    setDogFilter: (state, dogFilter) => { state.dogFilter = dogFilter },
    setCatFilter: (state, catFilter) => { state.catFilter = catFilter },
    setPresentationList: (state, presentationList) => { state.presentationList = presentationList },
    setPresentationFilter: (state, presentationFilter) => { state.presentationFilter = presentationFilter },
    setClassesList: (state, classesList) => { state.classesList = classesList },
    setClassesFilter: (state, classesFilter) => { state.classesFilter = classesFilter },
    setBrandList: (state, brandList) => { state.brandList = brandList },
    setBrandFilter: (state, brandFilter) => { state.brandFilter = brandFilter },
    setActivePrinciplesList: (state, activePrinciplesList) => { state.activePrinciplesList = activePrinciplesList },
    setActivePrinciplesFilter: (state, activePrinciplesFilter) => { state.activePrinciplesFilter = activePrinciplesFilter },
    setSystemFilter: (state, systemFilter) => { state.systemFilter = systemFilter },
    setSystemClasses: (state, systemClasses) => { state.systemClasses = systemClasses },

    setPetAges: (state, petAges) => { state.petAges = petAges },
    setPetAgesFilter: (state, petAgesFilter) => { state.petAgesFilter = petAgesFilter },

    setPetSizes: (state, petSizes) => { state.petSizes = petSizes },
    setPetSizesFilter: (state, petSizesFilter) => { state.petSizesFilter = petSizesFilter },

    setPetBreeds: (state, petBreeds) => { state.petBreeds = petBreeds },
    setPetBreedsFilter: (state, petBreedsFilter) => { state.petBreedsFilter = petBreedsFilter },

    setFeatures: (state, features) => { state.features = features },
    setFeaturesFilter: (state, featuresFilter) => { state.featuresFilter = featuresFilter },

    setBrandLines: (state, brandLines) => { state.brandLines = brandLines },
    setBrandLinesFilter: (state, brandLinesFilter) => { state.brandLinesFilter = brandLinesFilter },
    setLines: (state, lines) => { state.lines = lines },
}